module.exports = __webpack_public_path__ + "static/media/YourSpaceWelocming.519e7473.png";